import { create } from '@bufbuild/protobuf'
import _ from 'lodash'

import {
  type IRQCategorySeverity,
  IRQCategorySeveritySchema,
  type InherentRiskGroup,
} from '@/gen/inventory/v1/company_service_pb'
import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

/**
 * Computes IRQCategorySeverity[] from InherentRiskGroup[]
 * for cases where we don't have the pre-computed data from the API.
 */
export const computeCategorySeverities = (groups: InherentRiskGroup[]): IRQCategorySeverity[] => {
  const grouped = _.groupBy(groups, (g) => g.category)
  return Object.entries(grouped)
    .map(([category, categoryGroups]) => {
      const allItems = categoryGroups.flatMap((g) => g.inherentRiskItems)
      const maxSeverity = _.max(allItems.map(({ severity }) => severity)) || RiskLevel.UNSPECIFIED
      return create(IRQCategorySeveritySchema, {
        category,
        severity: maxSeverity,
      })
    })
    .filter(({ severity }) => severity !== RiskLevel.UNSPECIFIED)
}
